export default {
  select_to_share: 'Select Contacts or Channels to share',
  forward: 'Forward',
  cancel: 'Cancel',
};
